var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(" Мій профіль ")]),_c('p',[_vm._v(" Тут можна редагувати Ваші дані, провести верифікацію профілю, тощо ")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }